<template>
    <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white rounded-lg p-6 max-w-sm w-full mx-4">
        <h2 class="text-xl font-bold mb-4">Anda belum login</h2>
        <p class="mb-4">Anda harus login untuk {{ action }}.Harap login untuk melanjutakn.</p>
        <div class="flex justify-end space-x-2">
          <button
            @click="$emit('close')"
            class="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
          >
            Cancel
          </button>
          <button
            @click="goToLogin"
            class="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Login
          </button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'LoginPromptModal',
    props: {
      action: {
        type: String,
        required: true
      }
    },
    methods : {
      goToLogin() {
      this.$router.push('/login')
    }
    },
    emits: ['close', 'login']
  }
  </script>
  
  